<template>
	<div class="businessAdd">
		<div class="contentWrap" v-loading="isLoading" element-loading-text="拼命加载中"    element-loading-spinner="el-icon-loading"    element-loading-background="rgba(255, 255, 255, 0.8)">
			<!-- 第一块 -->
			<div class="panelBlock">
				<div class="panelTitle"></div>
				<div class="panelContent">
          <div class="oneLine">
            <div class="label">优惠券名称（不可以重复）</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入">
            </div>
          </div>
          <div class="oneLine">
            <div class="label">优惠券类型</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入">
            </div>
          </div>
          <div class="oneLine">
            <div class="label">最低消费金额</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入">
            </div>
          </div>
          <div class="oneLine">
            <div class="label">优惠金额</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入">
            </div>
          </div>
          <div class="oneLine">
            <div class="label">优惠券有效期</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入">
            </div>
          </div>
          <div class="oneLine">
            <div class="label">用户可领取时间</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入">
            </div>
          </div>
          <div class="oneLine">
            <div class="label">用户可领取数量（张）</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入">
            </div>
          </div>
          <div class="oneLine">
            <div class="label">加入领劵中心</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入">
            </div>
          </div>
          <div class="oneLine">
            <div class="label">优惠券数量</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入">
            </div>
          </div>
				</div>
			</div>
			
      <!-- button -->
      <div class="btnBox">
        <el-button type='primary'>提交</el-button>
      </div>

		</div>
	</div>
</template>

<script>
	import {json,wordData,utils} from '@/common/common.js'
	import { ajaxPost,api } from '@/common/request.js'
	export default {
		name: 'adminIndex',
		data() {
			return {
				currentPrevImg:'',
				isLoading:false,
				authId:"",
				djs:"",
				userId:"",
				headPic:"",
				licenseFile:"",
				userAuthFactoryPic:[],
				infoObj:{},
				regStrObj:{},
				canBuyFabricAbility:"",
				mainQuantityStr:[],
				handleNeedProcessingLink:[],
				handleSpecialProcess:[],
				product:[],//主营品类
				channelList:[],//主营渠道
				staffNumber:"",
				staffInfo:{
					employeeData:{},
					machineData:{}
				},
				userAuthRecordList:[],
				isShowModal:false,//审核的modal
				isShowImgModal:false,//图片预览
				currentAuthList:{},
				timer:'',
                href:'',

			}
		},
		computed: {
            functionAuthCustomer(){
                return utils.getCurrentFunction().indexOf("authCustomerIdentitySubmit")>-1
            },
			IMG_PREV(){
				return api.imgPrev
			}
		},
		components: {
		},
		methods: {
			prevImg(url){
				this.isShowImgModal=true
				this.currentPrevImg=url
			},

			getDjs(){
				let _this=this
				let endDate= this.infoObj.auth_user_submit_time
				if(endDate&&_this.infoObj.auth_result=='p'){
					_this.timer=setInterval(function(){
						console.log(_this.timer)
						_this.djs=utils.computeDjs(endDate,2)
					},1000)
				}


			},
			back(){
				this.$router.back()
			},
			closeModal(){
				this.isShowModal=false
			},
			openAuth(){
				let list={
					company_name:this.infoObj.company_name,
					user_id:this.infoObj.user_id,
					auth_id:this.infoObj.auth_id
				}
				this.currentAuthList=list
				this.isShowModal=true
			},
			getParam(){
				this.userId=this.$route.params.userId
				this.href=this.$route.params.href
			},
			getDetail(){
				let _this=this
				_this.isLoading=true
				let args={
					userId:_this.userId,
				}
				ajaxPost('/admin/yijiajiaUserAuth/getUserAuthByAId',args).then(function(res){
					_this.isLoading=false

					if(res.data){


					}




				},function(res){
					_this.isLoading=false
				})
			},

		},
		mounted() {
			let _this = this
			this.getParam()
		},
		destroyed(){
			let _this=this
			console.log(_this.timer,"销毁定时器")
			clearInterval(_this.timer)


		}
	}
</script>

<style scoped lang="scss">
	* {
		// outline: 1px solid blue;
	}
  .businessAdd{
    background: #fff;; padding:20px;padding-bottom:100px;
    .panelBlock{
      .panelTitle{font-weight: bold;padding:10px 0;}
      .panelContent{
        .oneLine{
          padding:10px;
          .label{display: inline-block;padding:0 20px;}
          .rightInput{display: inline-block;}
        }
      }
    }
    .btnBox{text-align: center;}
  }

</style>



// WEBPACK FOOTER //
// src/pages/discount/add.vue